/**
 * Errores de API con código estable — US-26.
 *
 * OBJETIVO de contrato (pendiente de VoBo de Cassie): que el kernel responda los
 * errores de administración con el envelope estructurado
 *   { "error": { "code": "...", "message": "..." } }
 * ADVERTENCIA: hoy el kernel real NO emite este envelope — devuelve un string
 * plano (p.ej. { "error": "no_autorizado" }). Por eso `apiError()` en client.js
 * deriva el `code` por status como fallback. Cuando el kernel migre al envelope
 * estructurado, este mapeo funcionará sin cambios en el front.
 * (El 401 global lo trata client.js/SessionContext aparte.)
 *
 * El front mapea `code` -> estado de UI (email ya existe, permiso denegado,
 * etc.), nunca el texto crudo del backend, para que la UI sea estable aunque el
 * mensaje del servidor cambie.
 */

export class ApiError extends Error {
  constructor(code, message, status = null) {
    super(message || code)
    this.name = 'ApiError'
    this.code = code
    this.status = status
  }
}

// Mensajes de UI por código. Fuente única para mock y real.
export const ERROR_MESSAGES = {
  forbidden:            'No tienes permiso de administrador para esta acción.',
  email_already_exists: 'Ya existe un usuario con ese email en el tenant.',
  invalid_email:        'El email no tiene un formato válido.',
  invalid_role:         'El rol indicado no es válido.',
  user_not_found:       'No se ha encontrado ese usuario.',
  self_role_change:     'No puedes cambiar tu propio rol de administrador.',
  last_admin:           'No puedes dejar el tenant sin ningún administrador.',
}

export function messageForCode(code, fallback) {
  return ERROR_MESSAGES[code] ?? fallback ?? 'Ha ocurrido un error inesperado.'
}
